module.exports = __webpack_public_path__ + "img/microplastics-8-mobile.d9493de9.png";